/**
 * T-0894 (`docs/concept-mobile-app.md`, LC-6g, its third part): the refusal of a sign-in link this
 * app did not start (I-1182), without the binding that decides it. A browser's entry names the error
 * in the sign-in's failure wording (`signInFailure.ts`) and `AuthApi`; the binding itself
 * (`desktopSignInBinding.ts`) loads through `desktopSessionLazy.ts`. It imports nothing.
 */

/** What the person reads when a link carried a code this app did not start. */
export const DESKTOP_FOREIGN_CODE_MESSAGE =
  'This sign-in link was not started in this app, so it was not used. Sign in again from here.';

/** Thrown when a link carried a code this app did not start; the message is the sentence to show. */
export class DesktopForeignCodeError extends Error {
  constructor() {
    super(DESKTOP_FOREIGN_CODE_MESSAGE);
    this.name = 'DesktopForeignCodeError';
  }
}
